import { Router, Route } from "@solidjs/router";
import { AppStateProvider } from "@core/state/AppState";
import { ProtectedLayout } from "@ui/components/ProtectedLayout";
import { LoginPage } from "@modules/auth/LoginPage";
import { ChatPage } from "@modules/chat/ChatPage";
import { SettingsPage } from "@modules/settings/SettingsPage";

export function App() {
  const setAppHeight = () => document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
  window.addEventListener('resize', setAppHeight);
  setAppHeight();
  return (
    <AppStateProvider>
      <Router>
        <Route path="/login" component={LoginPage} />
        <Route path="/" component={ProtectedLayout}>
          <Route path="/" component={ChatPage} />
          <Route path="/settings" component={SettingsPage} />
        </Route>
      </Router>
    </AppStateProvider>
  );
}
